'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');

const RedemptionHeader = require('./redemption-header');
const CouponButton = require('../../coupons/views/coupon-button');
const RedemptionTerms = require('./redemption-terms');
const OfferFinancialTerms = require('../../shared/views/offer/offer-financial-terms');

function RedemptionModalTerms({
  offerId,
  offerTitle,
  offerType,
  merchantId,
  merchantMedia,
  merchantName,
  expiryDateTime,
  isLimited,
  termsAndConditions,
  financialTerms,
  routes,
  referralSource,
}) {
  return h(
    '.redemption-modal-redeem',
    {
      'data-bhw': 'RedemptionModalTerms',
    },
    [
      h(RedemptionHeader, {
        routes,
        merchantId,
        merchantMedia,
        merchantName,
        offerTitle,
      }),
      h('.redemption-modal-content', [
        h(OfferFinancialTerms, {
          terms: financialTerms,
          className: 'redemption-modal-financial',
        }),
        CouponButton({
          coupon: { offerId, offerType },
          isLimited,
          routes,
          className: 'redemption-modal-button',
          referralSource,
        }),
      ]),
      h(
        '.redemption-modal-footer',
        h(RedemptionTerms, {
          termsAndConditions,
          expiryDateTime,
          notExpandable: true,
        })
      ),
    ]
  );
}

module.exports = hydrate('RedemptionModalTerms', RedemptionModalTerms);
